import './types';

export function isReady(): boolean {
  return typeof window.$respond?.do === 'function';
}

// Returns whether the command was delivered. The loader may still be booting
// when a user taps "Help" — that is an expected race, not an error condition.
export function openChat(): boolean {
  if (!isReady()) {
    return false;
  }
  try {
    window.$respond?.do('chat:open');
    return true;
  } catch {
    return false;
  }
}
